import React from 'react'
import { sortableHandle } from 'react-sortable-hoc';

export default function DragHandle() {

    const DragHandle = sortableHandle(() => (
        <span className='mr-2' style={{cursor: 'grab'}}>
            <i className="fa fa-grip-lines"></i>
        </span>
    ));
  return (
    <DragHandle />
  )
}
